import React, { useMemo, useState } from 'react';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import {
  DiagnosticCard,
  DiagnosticContainer,
  DiagnosticGrid,
  DiagnosticSummaryBar,
  FilterPill,
  SectionHeader,
} from './HistoryDetail.styles';

const AssessmentDiagnosticsCard = ({ app }) => {
  const [filter, setFilter] = useState('all'); // 'all' | 'pass' | 'issue'

  const checkRows = useMemo(() => {
    return (app.checkDetails || []).map((item) => {
      const normalized = String(item.answer || '').toLowerCase().trim();
      const isPass = normalized === 'yes' || normalized === 'pass' || normalized === 'ok' || normalized === 'working';
      return {
        ...item,
        isPass,
      };
    });
  }, [app.checkDetails]);

  const stats = useMemo(() => {
    const total = checkRows.length;
    const passed = checkRows.filter((q) => q.isPass).length;
    const issues = total - passed;
    return { total, passed, issues };
  }, [checkRows]);

  const filteredItems = useMemo(() => {
    if (filter === 'pass') return checkRows.filter((q) => q.isPass);
    if (filter === 'issue') return checkRows.filter((q) => !q.isPass);
    return checkRows;
  }, [checkRows, filter]);

  return (
    <DiagnosticContainer>
      <SectionHeader $color="#059669">
        <div className="section-title">
          <div className="section-icon">
            <SafetyCertificateOutlined />
          </div>
          <span>Assessment Diagnostics Matrix</span>
        </div>
      </SectionHeader>

      <DiagnosticSummaryBar>
        <div className="score-label">
          <CheckCircleFilled style={{ color: '#10b981', fontSize: 16 }} />
          <span>
            {stats.passed} of {stats.total} Checks Verified
          </span>
        </div>

        <div className="filter-pills">
          <FilterPill
            $active={filter === 'all'}
            onClick={() => setFilter('all')}
          >
            All ({stats.total})
          </FilterPill>
          <FilterPill
            $active={filter === 'pass'}
            onClick={() => setFilter('pass')}
          >
            Passed ({stats.passed})
          </FilterPill>
          {stats.issues > 0 && (
            <FilterPill
              $active={filter === 'issue'}
              onClick={() => setFilter('issue')}
            >
              Issues ({stats.issues})
            </FilterPill>
          )}
        </div>
      </DiagnosticSummaryBar>

      {filteredItems.length > 0 ? (
        <DiagnosticGrid>
          {filteredItems.map((item) => (
            <DiagnosticCard key={item.id} $isPass={item.isPass}>
              <div className="question-body">
                <div className="icon-wrap">
                  {item.isPass ? <CheckCircleFilled /> : <CloseCircleFilled />}
                </div>
                <div className="question-text">{item.question}</div>
              </div>

              <span className="status-tag">{item.answer || '-'}</span>
            </DiagnosticCard>
          ))}
        </DiagnosticGrid>
      ) : (
        <div style={{ textAlign: 'center', padding: '24px 0', color: '#94a3b8', fontSize: 13 }}>
          No diagnostic checks match the selected filter.
        </div>
      )}
    </DiagnosticContainer>
  );
};

export default AssessmentDiagnosticsCard;
